<template>
    <Link :href="route('podcasts.show', podcast)">
        <div class="rounded-xl">
            <div class="aspect-w-1 aspect-h-1 bg-center bg-cover rounded-lg" :style="'background-image: url(' + podcast.image + ')'" />
            <div class="py-2">
                <div v-if="podcast.category" class="text-xs font-medium text-regal-blue-700 line-clamp-1">
                    {{ podcast.category }}
                </div>
                <div class="font-medium text-sm md:text-base line-clamp-1">
                    {{ podcast.title }}
                </div>
                <div class="text-xs font-medium text-gray-700">
                    {{ podcast.episodes }}
                </div>
            </div>
        </div>
    </Link>
</template>

<script>
export default {
    props: [ 'podcast' ]
}
</script>
